var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "f85e58f81f4a8b9661023c0d2acad87c4776da33"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["frontend-nextrequest@nextrequest"] = {
  id: "f85e58f81f4a8b9661023c0d2acad87c4776da33"
};